import { useState, useParams, FaSearch, FaFileExcel, FaPlusCircle, MdArrowDownward, DataTable, FaEye, FaPencilAlt, FaTrash, noDatapng, ToastContainer, BiCategory, MdErrorOutline, FaArrowAltCircleRight } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import MidViewProducts from '../../middleware/Products/MidViewProducts';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import useNavigation from '../../common/useNavigation';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Modal, Form } from "react-bootstrap";
const ViewProducts = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, Remainuser, seacrh, setSearch, exporttoExcelData, filteredProducts, deleteProduct, handleToggleStatus } = MidViewProducts(type);
    const { handlenavigateAddProducts, navigateAddCategory, navigateEditProduct, navigateProductDetails } = useNavigation();
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var ActiveUser = users[0]["Status"]

    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }
    const columns = [

        {
            name: " Image",
            width: '150px',
            cell: (row) => {
                const data = row.product_main_image;
                return (
                    <div className="w-[70px] h-[70px] overflow-hidden flex items-center justify-center cursor-pointer">
                        {data !== '' ? (
                            <img
                                className="w-full h-full object-cover p-2 rounded-xl"
                                src={`${process.env.REACT_APP_API_URL}/api/productsphotos/uploads/${row.product_main_image}`}
                                alt="Product"
                            />
                        ) : (
                            <img
                                className="w-full h-full object-cover p-2 rounded-xl"
                                src={`${process.env.REACT_APP_API_URL}/uploads/noPreview.png`}
                                alt="No Preview"
                            />
                        )}
                    </div>
                );
            }
        },
        {
            name: " Name",
            style: {
                color: '#0089ff ',
                fontSize: '14px',
                fontWeight: '500',
                padding: '8px 16px',
            },
            sortable: true,
            //selector: 'product_name',
            selector: (row) => row.product_name,
            cell: row => {
                // function getKeyByValue(object, row) {
                //     // Data from coinName.js Object
                //     return object[row]; // Returns Korean Coin Name
                // }
                return (
                    <a
                        className="productName cursor-pointer hover:underline hover:text-blue-600"
                        onClick={() => navigateProductDetails(row.product_unique_id)}
                        target="_blank"
                        rel="noopener noreferrer">
                        {row.product_name}
                        {/* <span className="sub">
                            {getKeyByValue(row.product_name, row.id)}
                        </span> */}
                    </a>
                );
            },


        },
        {
            name: " Category",
            style: {
                color: '#545353 ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            // selector: (row) => row.product_cat_id,
            selector: (row) => row.product_string_name,
        },
        {
            name: " Available ",
            sortable: true,
            cell: (row) => (
                <div className="flex items-center gap-2">
                    {ActiveUser === 1 &&
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                checked={row.is_available === 1}
                                onChange={() => handleToggleStatus(row.product_unique_id, "available")}
                                className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-green-500 transition-colors duration-300"></div>
                            <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
                        </label>
                    }
                    <span className="text-sm font-medium">
                        {row.is_available === 1 ? "available" : "Unavailable"}
                    </span>
                </div>
            ),
        },
        // {
        //     name: "Status",
        //     sortable: true,
        //     cell: (row) => (
        //         <div className="flex items-center gap-2">
        //             <label className="relative inline-flex items-center cursor-pointer">
        //                 <input
        //                     type="checkbox"
        //                     checked={row.status === 1}
        //                     onChange={() => handleToggleStatus(row.product_unique_id, "status")}
        //                     className="sr-only peer"
        //                 />
        //                 <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-green-500 transition-colors duration-300"></div>
        //                 <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
        //             </label>
        //             <span className="text-sm font-medium">
        //                 {row.status === 1 ? "Active" : "Inactive"}
        //             </span>
        //         </div>
        //     ),
        // },
        {
            name: " Visible ",
            sortable: true,
            cell: (row) => (
                <div className="flex items-center gap-2">
                    {ActiveUser === 1 &&
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                checked={row.is_visible === 1}
                                onChange={() => handleToggleStatus(row.product_unique_id, "visible")}
                                className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-green-500 transition-colors duration-300"></div>
                            <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
                        </label>
                    }
                    <span className="text-sm font-medium">
                        {row.is_visible === 1 ? "visible" : "InVisible"}
                    </span>
                </div>
            ),
        },
        {
            name: "Action",
            selector: (row) => <div className='flex flex-col lg:flex-row space-x-2 '>

                {ActiveUser === 1 &&
                    <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10" onClick={() => navigateEditProduct(row.product_unique_id)}>
                        <FaPencilAlt className='text-[#193b99] m-auto' />
                    </Button>
                }

                {ActiveUser === 1 &&
                    <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10 text-center " onClick={() => deleteProduct(row.product_unique_id)}>
                        <FaTrash className='text-red-700 m-auto' />
                    </Button>
                }

            </div>,
        },
    ]


    const activeProducts = filteredProducts?.filter(
  (row) => row.status !== 0
);

    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="grid grid-cols-12 ">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 mx-3 text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'>Products </h1>
                                <p className=' text-gray-600 text-[16px] '>Manage products with required details and optional attributes, displaying only what’s relevant to buyers.</p>
                            </div>
                        </div>
                        <div className="col-start-1 col-end-13">
                            <div className="border-0 flex-row rounded-xl m-3 p-3 bg-white shadow-xs">
                                <div className=' relative flex flex-col min-w-0 break-words'>
                                    <div className='p-2'>
                                        <div className="flex flex-col lg:flex-row justify-between items-center w-full space-y-3 lg:space-y-0">
                                            {/* Search Section */}
                                            <div className="w-full lg:w-auto">
                                                <div className="relative bg-gray-100 rounded-md border-2 border-gray-200">
                                                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-500" />
                                                    <input
                                                        id="searchbox"
                                                        type="text"
                                                        name="searchbox"
                                                        placeholder="Search records…"
                                                        className="bg-transparent pl-10 pr-4 py-2 w-full lg:w-64 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-md text-sm placeholder-gray-500"
                                                        value={seacrh}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                        aria-label="Search"
                                                    />
                                                </div>
                                            </div>

                                            {/* Button Section */}
                                            <div className="flex flex-wrap justify-center lg:justify-end gap-2">
                                                <Button
                                                    variant="success"
                                                    className="d-flex align-items-center !bg-[#005f0b] border-[1px] border-[#005f0b] border-solid"
                                                    onClick={() => exporttoExcelData()}
                                                >
                                                    <FaFileExcel className="mr-2" />
                                                    Download Excel
                                                </Button>

                                                {ActiveUser === 1 &&
                                                    <Button
                                                        variant="primary"
                                                        className="d-flex align-items-center"
                                                        onClick={navigateAddCategory}
                                                    >
                                                        <FaPlusCircle className="mr-2" />
                                                        Add New Category
                                                    </Button>
                                                }

                                                {ActiveUser === 1 &&
                                                    <Button
                                                        variant="primary"
                                                        className="d-flex align-items-center"
                                                        onClick={handlenavigateAddProducts}
                                                    >
                                                        <FaPlusCircle className="mr-2" />
                                                        Add Product
                                                    </Button>
                                                }


                                                {/* Mobile Dropdown */}
                                                <DropdownButton
                                                    as={ButtonGroup}
                                                    title="Dropdown"
                                                    id="bg-vertical-dropdown-3"
                                                    className="block lg:!hidden"
                                                >
                                                    <Dropdown.Item eventKey="1">Dropdown link</Dropdown.Item>
                                                    <Dropdown.Item eventKey="2">Dropdown link</Dropdown.Item>
                                                </DropdownButton>
                                            </div>
                                        </div>

                                        {activeProducts && activeProducts.length > 0 ? (
                                            <DataTable
                                                // title="Categories"
                                                columns={columns}
                                                data={activeProducts}

                                                // selectableRows
                                                pagination
                                                // expandableRows={true}
                                                // expandableRowsComponent={ExpandedComponent}
                                                // expandableRowExpanded={() => !true}
                                                // selectableRowsComponent={Checkbox} // Pass the function only
                                                //selectableRowsComponentProps={{ inkDisabled: true }} // optionally, pass Material Ui supported props down to our custom checkbox
                                                sortIcon={<MdArrowDownward />} // use a material icon for our sort icon. rdt will rotate the icon 180 degrees for you
                                            />

                                        ) : (
                                            <center>
                                                <img src={noDatapng} height={300} width={300} />
                                                <h1 className='text-lg -translate-y-20 text-gray-300 font-bold'> No Data Exist! </h1>
                                            </center>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewProducts